import PropTypes from "prop-types";
import React from 'react';
import TestimonialData from '../../data/testimonial/testimonial.json'
// import Testimonial from '../../components/Testimonial/Testimonial.jsx';
import SectionTitle from '../../components/SectionTitles/SectionTitle';
import SwiperCore, { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import './TestCss.css'

import 'swiper/components/pagination/pagination.scss';
import TestimonialBox from "../../components/Testimonial/TestimonialBox";

SwiperCore.use([ Pagination ]);

const TestimonialSlider = ({ classOption }) => {
    return (
        <div className={`testimonial-section section  content-paddingTopBottom ${classOption}`}  style={{margin:'20px 0px'}}>
            <div className="container-fluid pl-xl-16 pl-lg-3 pl-md-3 pl-sm-3 pl-3 pr-xl-16 pr-lg-3 pr-md-3 pr-sm-3 pr-3" >
                <SectionTitle
                    
                    title="You Are Our Universe"
                    subTitle="See what our customers say about us"
                />




                <Swiper className="testimonial-slider mt-7"data-aos="fade-up" data-aos-delay="300"
                // style={{width:'100%'}}
                spaceBetween={-50}
                slidesPerView={3}
                centeredSlides
                loop
                pagination={{ clickable: true}}
                navigation  
                breakpoints= {{
                    1499:{
                        slidesPerView : 3
                    },

                    991:{
                        slidesPerView : 3
                    },

                    767:{
                        slidesPerView : 1

                    },

                    575:{
                        slidesPerView : 1
                    },
                    479:{
                        slidesPerView : 1
                    },
                    425:{
                        slidesPerView : 1
                    },
                    375:{
                        slidesPerView : 1
                    } , 
                     320:{
                        slidesPerView : 1
                    }



                }}
                
                >

                    {TestimonialData &&
                        TestimonialData.map((single, key) => {
                            return(
                                <SwiperSlide key={key}>
                                    <TestimonialBox data={single} key={key} />
                                </SwiperSlide>
                            ); 
                    })}

                        
                </Swiper>
            </div>

            



        </div>
    )
}

TestimonialSlider.propTypes = {
    classOption: PropTypes.string
};
TestimonialSlider.defaultProps = {
    classOption: "testimonial-section section "
};

export default TestimonialSlider;
